// extracted by mini-css-extract-plugin
export default {"bar":"MultiDayBar_bar__6yZvk","accent":"MultiDayBar_accent__-tpvS","content":"MultiDayBar_content__OXcsz","badge":"MultiDayBar_badge__Mjl1D","title":"MultiDayBar_title__StTeH"};